import { ListChart, ListChartProps } from '../../../renderers/list-chart/list-chart.component';
import { STOCK_VOLUME_BY_PRODUCT_LIST_CHART_DEFINITION } from './stock-volume-by-product-list-chart.definition';
import { STOCK_VOLUME_BY_PRODUCT_LIST_CHART_MOCK_DATA } from './stock-volume-by-product-list-chart.mock';

export const StockVolumeByProductListChart = (props: ListChartProps) => <ListChart {...props} />;

StockVolumeByProductListChart.definition = STOCK_VOLUME_BY_PRODUCT_LIST_CHART_DEFINITION;
StockVolumeByProductListChart.mockData = STOCK_VOLUME_BY_PRODUCT_LIST_CHART_MOCK_DATA;
